<div class="pan-page-inner flex flex-grow flex-column bottom-action-mg">
    <div class="pan-page-header" fxLayout="row" fxLayoutAlign="center center">
        <!-- <div class="pan-page-back">
            <button mat-icon-button (click)="sendBack()">
                <mat-icon class="text-primary">arrow_back_ios</mat-icon>
            </button>
        </div> -->
        <p fxFlex="33%"></p>
        <p class="pv-xxs mat-title text-primary upper" fxFlex="33%" align="center">
            {{ title }}
        </p>
        <p fxFlex="33%" align="right"><span *ngIf="rightText">Ostatnie obliczenie: {{ rightText }}</span></p>
    </div>
    <div class="pan-page-info" fxLayout="row wrap">
        <ng-content select="[page-panel-center]"></ng-content>
        <ng-content select="[page-panel-left]"></ng-content>
        <ng-content select="[page-panel-right]"></ng-content>
        <ng-content select="[page-panel-actions]"></ng-content> 
    </div>
</div>